
<template>
    
        <mars-view class="item-wrapper"><mars-view class="item c-font-normal"><mars-view v-if="text" :style="[
                {
                    'color': selected || (type === 'order' && direction)
                        ? selectedColor
                        : color,
                    'font-weight': selected || (type === 'order' && direction) && selectedItemBold
                        ? 'bold'
                        : ''
                }
            ]" class="text c-line-clamp1">
            {{ text }}
        </mars-view><mars-view v-if="type === 'order'" class="order-wrapper c-gap-left-small"><c-triangle :direction="2" :color="
                    direction === 'up'
                        ? selectedColor
                        : color
                " :default-line-height="false" top="7px" class="order-top" v-animation="false"></c-triangle><c-triangle :direction="1" :color="
                    direction === 'down'
                        ? selectedColor
                        : color
                " :default-line-height="false" top="7px" class="order-bottom" v-animation="false"></c-triangle></mars-view><c-triangle v-else :direction="
                up
                    ? 2
                    : 1
            " :color="
                selected
                    ? selectedColor
                        ? selectedColor
                        : '#333'
                    : color
            " top="10px" class="c-gap-left-small"></c-triangle></mars-view></mars-view>
    
</template>

<script>
import Triangle from "../Icon/Triangle.vue";
export default {
  components: {
    'c-triangle': Triangle
  },
  props: {
    /**
     * 文案
     */
    text: String,

    /**
     * 索引
     */
    index: Number,

    /**
     * 类型：normal 正常；order 排序；
     */
    type: {
      type: String,
      default: 'normal'
    },

    /**
     * 是否向上；主要是为了解决 normal 普通类型
     */
    up: {
      type: Boolean
    },

    /**
     * 方向：up 向上；down 向下；主要是为了解决 order 排序类型
     */
    direction: {
      type: String
    },

    /**
     * 强制选中
     */
    selected: {
      type: Boolean,
      default: false
    },

    /**
     * 默认颜色
     */
    color: {
      type: String,
      default: '#666'
    },

    /**
     * 选中颜色
     */
    selectedColor: {
      type: String,
      default: '#333'
    },

    /**
     * 选中项是否加粗
     */
    selectedItemBold: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.item-wrapper {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}
.item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.text {
  display: inline;
  font-size: 15px;
  line-height: 25px;
}
.order-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.order-wrapper .order-top,
.order-wrapper .order-bottom {
  height: 4px;
}
.order-wrapper .order-bottom {
  margin-top: 2px;
}

</style>
